import React from 'react'
import type { BriefNavSteps } from 'features/briefs/utils/nav'
import { getStepLink, NAVIGATION_STEPS } from 'features/briefs/utils/nav'
import Button from 'components/ui/button'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import {
  getValidBriefSteps,
  sendBrief,
  getBrief,
} from '@disco/state-management/reducers/entities/briefs'
import { isContactsLoaded } from '@disco/state-management/selectors/contacts-all'

interface BriefNextButtonProps {
  briefId: string
  currentStep: BriefNavSteps
}

export const BriefNextButton: React.FC<BriefNextButtonProps> = ({
  briefId,
  currentStep,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const validBriefSteps = useSelector(state =>
    getValidBriefSteps(state, { briefId: parseInt(briefId) }),
  )

  const brief = useSelector(state =>
    getBrief(state, { briefId: parseInt(briefId) }),
  )

  const contactsLoaded = useSelector(isContactsLoaded)

  const isLastStep =
    currentStep === NAVIGATION_STEPS[NAVIGATION_STEPS.length - 1]

  const nextStep = isLastStep
    ? null
    : getStepLink(
        briefId,
        NAVIGATION_STEPS[NAVIGATION_STEPS.indexOf(currentStep) + 1],
      )

  const onNextClick = () => {
    if (nextStep) {
      navigate(nextStep)
    }
  }

  if (isLastStep) {
    return (
      <Button
        appearance="primary"
        caption="Send brief"
        progressIndicator={brief?.sending}
        progressCaption={'Sending'}
        disabled={
          !validBriefSteps.sendAllowed || !contactsLoaded || brief?.sending
        }
        onClick={() => dispatch(sendBrief(parseInt(briefId)))}
      />
    )
  }

  return (
    <Button
      appearance="primary"
      caption="Next"
      disabled={!nextStep}
      onClick={onNextClick}
    />
  )
}
